import styled, { keyframes } from 'styled-components'

interface IsActive { $isActive: boolean }

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`

const fadeOut = keyframes`
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
`

export const CarouselContainer = styled.div`
  aspect-ratio: 613 / 504;
  border-radius: 20px;
  display: flex;
  flex: 1;
  max-width: 613px;
  max-height: 504px;
  position: relative;
  overflow: hidden;

  @media (max-width: 950px) {
    aspect-ratio: 1;
  }
`

export const Slide = styled.div<IsActive>`
  align-items: center;
  aspect-ratio: 613 / 504;
  animation: ${({ $isActive }) => $isActive ? fadeIn : fadeOut} 1s;
  display: flex;
  height: auto;
  justify-content: center;
  opacity: ${({ $isActive }) => $isActive ? 1 : 0};
  max-height: 504px;
  max-width: 613px;
  position: absolute;
  transition: opacity 1s ease-in-out;
  width: 100%;

  img {
    border-radius: 20px;
    width: 100%;
  }

  @media (max-width: 950px) {
    aspect-ratio: 1;
  }
`

export const DotsContainer = styled.div`
  bottom: 10px;
  display: flex;
  left: 50%;
  gap: 5px;
  position: absolute;
  transform: translateX(-50%);
`

export const Dot = styled.div<IsActive>`
  background-color: ${({ $isActive }) => $isActive ? '#62C1D0' : 'transparent'};
  border: ${({ $isActive }) => !$isActive && '1px solid #62C1D0'};
  border-radius: 50%;
  cursor: pointer;
  height: 16px;
  width: 16px;
`
